import React, { useState, useEffect } from "react";
import {
    TextField,
    Autocomplete
} from "@mui/material";
import {
    useNotify,
    useDataProvider
} from 'react-admin';

export const AutocompleteInput = React.forwardRef((props: any, ref) => {
    const { label, value, name, required, onChange, onNewItem = () => {}, onChangeData = 'property' , property = 'id', creatable = false, error = false, helperText, getOptionLabel = () => {}, resource, multiple } = props;

    const notify = useNotify();
    const dataProvider = useDataProvider();
    const [inputValue, setInputValue] = useState('');
    const [transformedValue, setTransformedValue] = useState(multiple ? [] : {});
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getItems(value);
    }, [value]);

    const getItems = (value?: string|Array<number>) => {
        if (multiple && Array.isArray(value)) {
            setLoading(true);
            dataProvider.get(resource, value ? { limit: 25, filters: {'id.in': value.join(',')} } : { limit: 25 }).then(({ data }) => {
                setLoading(false);
                setItems(data.results);
                setTransformedValue(data.results);
            })
            .catch((error) => {
                setLoading(false);
                notify(error.message, { type: 'warning' });
            });
        } else if (value && inputValue == "") {
            setLoading(true);
            dataProvider.get(resource, value ? { limit: 25, filters: {[property]: value} } : { limit: 25 }).then(({ data }) => {
                setLoading(false);
                setItems(data.results);

                if (value) {
                    for (const item of data.results) {
                        if (item[property] == value) {
                            setInputValue(item[property]);
                            setTransformedValue(item);
                        }
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                notify(error.message, { type: 'warning' });
            });
        } else {
            setLoading(true);
            dataProvider.get(resource, value ? { limit: 25, search: value } : { limit: 25 }).then(({ data }) => {
                setLoading(false);
                setItems(data.results);
            })
            .catch((error) => {
                setLoading(false);
                notify(error.message, { type: 'warning' });
            });
        }
    };

    return (
        <>
            <Autocomplete
                size="small"
                options={items}
                freeSolo
                value={transformedValue}
                onChange={(event, value) => {
                    if (value) {
                        if (creatable && value?.id === 'new') {
                            setInputValue('');
                            onNewItem(value.value);
                            
                            return;
                        }

                        if (multiple) {
                            let values = [];
                            for (const item of value) {
                                values.push(onChangeData === 'object' ? item : item[property]);
                            }

                            onChange(onChangeData === 'object' ? values : values.join(','), name)
                        } else {
                            onChange(onChangeData === 'object' ? value : value[property], name)
                        }
                    } else {
                        onChange('', name)
                    }
                }}
                loading={loading}
                inputValue={inputValue}
                onInputChange={(event, value) => {
                    setInputValue(value);
                    getItems(value);
                }}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    label={label}
                    required={required}
                    error={error}
                    helperText={helperText}
                    />
                )}
                isOptionEqualToValue={(option, value) => {
                    return value[property] === option[property];
                }}
                getOptionLabel={getOptionLabel}
                sx={{flex: "1"}}
                multiple={multiple}
                selectOnFocus
                handleHomeEndKeys
                filterOptions={(options, params) => {
                    if (creatable && !options.length && params.inputValue !== '') {
                        options.push({
                            [property]: 'new',
                            name: `Add "${params.inputValue}"`,
                            value: params.inputValue
                        });
                    }

                    return options;
                }}
            />
        </>
    );
});
